import axios from '@/libs/api.request'
//测试 获取table
export const getTableData = () => {
  return axios.request({
    url: 'https://www.easy-mock.com/mock/5add9213ce4d0e69998a6f51/iview-admin/get_table_data',
    method: 'get'
  })
}

// 获取员工花名册
export const getRosterData = () => {
  return axios.request({
    url: 'https://www.easy-mock.com/mock/5b8f4d20830bb75e3ad4c52d/ehr/get_roster_data',
  })
}

// 获取年假管理
// export const getAnnualData = () => {
//   return axios.request({
//     url: 'https://www.easy-mock.com/mock/5b8f4d20830bb75e3ad4c52d/ehr/get_annual_data',
//   })
// }
//测试 获取table  mock



// 组织架构
export const getDepartmentList = (data) => {
  return axios.request({
    url: '/enterprise/department/list/',
    params:data,
    method: 'get'
  })
}

// 组织架构（精简）
export const getDepartmentListSimple = (data) => {
  return axios.request({
    url: '/enterprise/department/listsimple/',
    params:data,
    method: 'get'
  })
}

// 岗位词典
export const getPosDicList = (data) => {
  return axios.request({
    url: '/enterprise/jobposition/dictionary/list/',
    params: data,
    method: 'post'
  })
}
// 岗位职级
export const getPosLevelList = (data) => {
  return axios.request({
    url: '/enterprise/jobposition/level/list/',
    params: data,
    method: 'get'
  })
}

// 岗位类别
export const getPosCateList = (data) => {
  return axios.request({
    url: '/enterprise/jobposition/category/list/',
    params: data,
    method: 'post'
  })
}
// 岗位列表
export const getPosList = (data) => {
  return axios.request({
    url: '/enterprise/jobposition/list/',
    params: data,
    method: 'post'
  })
}

// 岗位类别精简
export const getPosCateListSimple = (data) => {
  return axios.request({
    url: '/enterprise/jobposition/category/listsimple/',
    params: data,
    method: 'get'
  })
}
export const getContractList = (data) => {
  return axios.request({
    url: '/employee/relation/contractlist',
    params: data,
    method: 'post'
  })
}
// 企业信息
export const corpDetail = (data) => {
  return axios.request({
    url: '/enterprise/information',
    params:data,
    method: 'post'
  })
}
// 账户联系人信息
export const accountInfo = (data) => {
  return axios.request({
    url: '/enterprise/contract/information/',
    params:data,
    method: 'get'
  })
}
// 企业字典集合
export const corpSet = (data) => {
  return axios.request({
    url: '/option/areadictionary/enterprise',
    data,
    method: 'POST'
  })
}

// 组织详情
export const getDepartmentDetail = (data) => {
  return axios.request({
    url: '/enterprise/department/detail/',
    params:data,
    method: 'get'
  })
}

// 组织编辑
export const departmentDetailEdit = (data) => {
  return axios.request({
    url: '/enterprise/department/edit/',
    params:data,
    method: 'post'
  })
}

// 添加组织
export const addOrz = (data) => {
  return axios.request({
    url: '/enterprise/department/add/',
    data,
    method: 'POST'
  })
}
// 合并组织
export const mergeOrz = (data) => {
  return axios.request({
    url: '/enterprise/department/merge/',
    data,
    method: 'POST'
  })
}

//删除组织
export const delOrz = (data) => {
  return axios.request({
    url: '/enterprise/department/delete/',
    data,
    method: 'POST'
  })
}

//-员工字典集合
export const employeeSet = (data) => {
  return axios.request({
    url: '/option/areadictionary/employee/',
    data,
    method: 'POST'
  })
}

//-字典-添加员工时员工状态【韩雪龙】
export const employeeaddstatus = (data) => {
  return axios.request({
    url: '/option/dictionary/employeeaddstatus',
    data,
    method: 'POST'
  })
}


//-字典-工资表时员工状态【韩雪龙】
export const employeesalarystatus = (data) => {
  return axios.request({
    url: '/option/dictionary/employeesalarystatus',
    data,
    method: 'POST'
  })
}



// 岗位词典列表
export const jobpositionDictionary = (data) => {
  return axios.request({
    url: '/enterprise/jobposition/listsimple/',
    data,
    method: 'POST'
  })
}


// 员工合同隶属公司列表
export const employeeCompanyList = (data) => {
  return axios.request({
    url: '/enterprise/company/list',
    data,
    method: 'POST'
  })
}

// 员工花名册
export const employeeList = (data) => {
  return axios.request({
    url: '/employee/list/',
    params:data,
    method: 'GET'
  })
}

// 员工花名册 精简
export const employeeListSimple = (data) => {
  return axios.request({
    url: '/employee/listsimple/',
    params:data,
    method: 'GET'
  })
}
export const personaldetail = (data) => { //员工个人信息 银行卡 社保卡 教育 工作经历
  return axios.request({
    url: '/employee/personaldetail/',
    params:data,
    method: 'GET'
  })
}
export const contactdetail = (data) => { //员工联系信息，家庭成员信息
  return axios.request({
    url: '/employee/contactdetail/',
    params:data,
    method: 'GET'
  })
}
export const positiondetail = (data) => { //员工岗位信息,职业证书信息
  return axios.request({
    url: '/employee/positondetail/',
    params:data,
    method: 'GET'
  })
}
export const contractdetail = (data) => { //员工合同信息，招聘信息
  return axios.request({
    url: '/employee/contractdetail/',
    params:data,
    method: 'GET'
  })
}

// 员工主要信息-社保详情使用
export const employeeMainInfo = (data) => {
  return axios.request({
    url: '/employee/detail/',
    params: data,
    method: 'get'
  })
}

// 省市区
export const pcalist = (data) => {
  return axios.request({
    url: '/city/pcalist/',
    data,
    method: 'POST'
  })
}

// 职级列表-精简数据
export const positionLevelListSimple = (data) => { //员工岗位信息,职业证书信息
  return axios.request({
    url: '/enterprise/jobposition/level/listsimple/',
    params:data,
    method: 'GET'
  })
}

// emp-获取员工调岗信息--【
export const employeetransferinfo = (data) => {
  return axios.request({
    url: '/employee/employeetransferinfo/',
    params:data,
    method: 'GET'
  })
}

// 合同续签次数
export const contractrenewcount = (data) => {
  return axios.request({
    url: '/option/dictionary/contractrenewcount/',
    data,
    method: 'POST'
  })
}

// 合同类型
export const contracttype = (data) => {
  return axios.request({
    url: '/option/dictionary/contracttype/',
    data,
    method: 'POST'
  })
}
// 合同字典集合
export const contract = (data) => {
  return axios.request({
    url: '/option/areadictionary/contract',
    data,
    method: 'POST'
  })
}
//-招聘渠道
export const recruitmentchannels = (data) => {
  return axios.request({
    url: '/option/dictionary/recruitmentchannels/',
    data,
    method: 'POST'
  })
}

// 员工搜索控件，姓名、全拼、简拼
export const employeeSearch = (data) => {
  return axios.request({
    url: '/employee/search/',
    data,
    method: 'POST'
  })
}


// 字典-工作性质【韩雪龙】
export const employeenature = (data) => {
  return axios.request({
    url: '/option/dictionary/employeenature',
    data,
    method: 'POST'
  })
}




// 社保方案列表
export const insPlanList = (data) => {
  return axios.request({
    url: '/Insurance/Plan/List',
    data,
    method: 'post'
  })
}

//获取城市保险方案详情
export const pcaInsDtl = (data) => {
  return axios.request({
    url: '/Insurance/City/GetDetails',
    data,
    method: 'post'
  })
}

//社保方案详情
export const insPlanDetail = (data) => {
  return axios.request({
    url: '/Insurance/Plan/Details',
    data,
    method: 'post'
  })
}


// 1001】获取企业下假期类型【李旭阳】
export const holidayTypes = (data) => {
  return axios.request({
    url: '/holiday/types',
    data,
    method: 'post'
  })
}

// 开启关闭企业假期类型【李旭阳】
export const holidaySetTypes = (data) => {
  return axios.request({
    url: '/holiday/setTypes',
    data,
    method: 'post'
  })
}


// 【1004】获取假期类型中是否包含默认假期方案【李旭阳】
export const checkIsContainDefaultSolution = (data) => {
  return axios.request({
    url: '/holiday/checkIsContainDefaultSolution',
    data,
    method: 'post'
  })
}


// 【1010】获取假期方案详情【李旭阳】
export const solutionInfo = (data) => {
  return axios.request({
    url: '/holiday/solutionInfo',
    data,
    method: 'post'
  })
}

// 1011】获取假期方案列表【李旭阳】
export const solutionList = (data) => {
  return axios.request({
    url: '/holiday/solutionList',
    data,
    method: 'post'
  })
}


// 1036】获取假期方案详情【李旭阳】
export const holidaySolution = (data) => {
  return axios.request({
    url: '/app/Attendance/holidaySolution',
    data,
    method: 'post'
  })
}

// 获取年假管理
export const getAnnualData = (data) => {
  return axios.request({
    url: '/report/AnnualLeave',
    data,
    method: 'post'
  })
}

// 获取调休管理
export const getTuneData = (data) => {
  return axios.request({
    url: '/report/DaysOff',
    data,
    method: 'post'
  })
}


// 员工保险列表-全部
export const insAllList = (data) => {
  return axios.request({
    url: '/Insurance/EmployeeList/GetAllList',
    data,
    method: 'post'
  })
}

// 员工保险列表-正常缴纳
export const insPayList = (data) => {
  return axios.request({
    url: '/Insurance/EmployeeList/GetPayList',
    data,
    method: 'post'
  })
}

// 员工保险列表-未缴纳
export const insUnPaidList = (data) => {
  return axios.request({
    url: '/Insurance/EmployeeList/GetUnpaidList',
    data,
    method: 'post'
  })
}

// 员工保险列表-新增
export const insAddList = (data) => {
  return axios.request({
    url: '/Insurance/EmployeeList/GetAddList',
    data,
    method: 'post'
  })
}

// 员工保险列表-补缴
export const insRepayList = (data) => {
  return axios.request({
    url: '/Insurance/EmployeeList/GetRepayList',
    data,
    method: 'post'
  })
}

// 员工保险列表-中断
export const insStopList = (data) => {
  return axios.request({
    url: '/Insurance/EmployeeList/GetStopList',
    data,
    method: 'post'
  })
}

// 员工保险列表-离职
export const insQuitList = (data) => {
  return axios.request({
    url: '/Insurance/EmployeeList/GetQuitList',
    data,
    method: 'post'
  })
}

// 员工保险列表-各列表数量
export const insListCount = (data) => {
  return axios.request({
    url: '/Insurance/EmployeeList/GetListCount',
    data,
    method: 'post'
  })
}


// 员工保险异动详情
export const insChangeDtl = (data) => {
  return axios.request({
    url: '/Insurance/Change/Detail',
    data,
    method: 'post'
  })
}

// 员工保险费用详情
export const insEmplDtl = (data) => {
  return axios.request({
    url: '/Insurance/Employee/Detail',
    data,
    method: 'post'
  })
}

// 员工保险状态
export const insEmplStatus = (data) => {
  return axios.request({
    url: '/Insurance/EmployeeStatus/GetEmployeeStuatus',
    data,
    method: 'post'
  })
}

//根据参保方案生成费用
export const creatCost = (data) => {
  return axios.request({
    url: '/Insurance/Cost/AddBillByPlan',
    data,
    method: 'post'
  })
}

// 考勤规则 （方案）

//考勤方案列表
export const ruleSolutionList = (data) => {
  return axios.request({
    url: '/solution/list',
    data,
    method: 'post'
  })
}

// 员工未参保的保险类型
export const unInsType = (data) => {
  return axios.request({
    url: '/Insurance/EmployeeStatus/GetUninsuredTypeList',
    data,
    method: 'post'
  })
}

//考勤方案详情
export const ruleSolutionInfo = (data) => {
  return axios.request({
    url: '/solution/info',
    data,
    method: 'post'
  })
}

// 员工是否已参保
export const haveIns = (data) => {
  return axios.request({
    url: '/Insurance/EmployeeStatus/IsHaveInsurance',
    data,
    method: 'post'
  })
}

// 获取考勤组列表【李旭阳】
export const groupList = (data) => {
  return axios.request({
    url: '/group/list',
    data,
    method: 'post'
  })
}

// 获取考勤组详情【李旭阳】
export const groupInfo = (data) => {
  return axios.request({
    url: '/group/info',
    data,
    method: 'post'
  })
}

// 获取考勤组班次列表【李旭阳】
export const workShiftList = (data) => {
  return axios.request({
    url: '/group/workShiftList',
    data,
    method: 'post'
  })
}

// 获取考勤组班次详情【李旭阳】
export const workShiftInfo = (data) => {
  return axios.request({
    url: '/group/workShiftInfo',
    data,
    method: 'post'
  })
}
// 更新考勤组班次【李旭阳】
export const workShiftUpdate = (data) => {
  return axios.request({
    url: '/group/workShiftUpdate',
    data,
    method: 'post'
  })
}


// 保险费用月汇总列表
export const insSummaryList = (data) => {
  return axios.request({
    url: '/Insurance/Cost/SummaryList',
    data,
    method: 'post'
  })
}

// 账单明细列表
export const insCostList = (data) => {
  return axios.request({
    url: '/Insurance/Cost/CostList',
    data,
    method: 'post'
  })
}

// 异动明细列表
export const insChgList = (data) => {
  return axios.request({
    url: '/Insurance/Change/List',
    data,
    method: 'post'
  })
}

//获取考勤方案请假标准字典【李旭阳】
export const standardDict = (data) => {
  return axios.request({
    url: '/holiday/standardDict',
    data,
    method: 'post'
  })
}
// 薪酬--导入历史薪酬月份【韩雪龙】
export const historysalaryMonthList = (data) => {
  return axios.request({
    url: '/salary/historysalary/monthlist',
    data,
    method: 'post'
  })
}
// 薪酬结构--列表【王龙】
export const getSalaryStructureList = (data) => {
  return axios.request({
    url: '/salary/structure/list',
    params:data,
    method: 'get'
  })
}

// 计薪方案--列表【王龙】
export const salaryPayableList = (data) => {
  return axios.request({
    url: '/salary/payable/list',
    params:data,
    method: 'get'
  })
}


// 计薪方案-详情【王龙】
export const salaryPayableDetail = (data) => {
  return axios.request({
    url: '/salary/payable/detail',
    params:data,
    method: 'get'
  })
}

// 计薪方案--迟到早退扣款类型【王龙】
export const salaryPayableLatedeductiontype = (data) => {
  return axios.request({
    url: '/salary/payable/latedeductiontype',
    params:data,
    method: 'get'
  })
}


// 计薪方案--固定和浮动工资项列表【王龙】
export const salaryPayableListdeduction = (data) => {
  return axios.request({
    url: '/salary/payable/listdeduction',
    params:data,
    method: 'get'
  })
}


// 字典-员工状态【韩雪龙】
export const employeeStatus = (data) => {
  return axios.request({
    url: '/option/dictionary/employeestatus',
    params:data,
    method: 'get'
  })
}

// 薪酬-企业设置-详情
export const salaryCorpSet = (data) => {
  return axios.request({
    url: '/salary/setting/detail/',
    params: data,
    method: 'get'
  })
}

// 薪酬--员工薪酬详情【韩雪龙】
export const empsalaryinfo = (data) => {
  return axios.request({
    url: '/salary/historysalary/empsalaryinfo',
    data,
    method: 'post'
  })
}

// 薪酬--员工历史月薪酬详情【韩雪龙】
export const historyempsalaryinfo = (data) => {
  return axios.request({
    url: '/salary/historysalary/historyempsalaryinfo',
    data,
    method: 'post'
  })
}



// 薪酬计税方案--列表【韩雪龙】
export const taxList = (data) => {
  return axios.request({
    url: '/salary/tax/list/',
    params:data,
    method: 'get'
  })
}

// 薪酬计税方案--详情【韩雪龙】
export const taxInfo = (data) => {
  return axios.request({
    url: '/salary/tax/info/',
    data,
    method: 'post'
  })
}

// 薪酬津贴方案--津贴项【韩雪龙】
export const allowanceItem = (data) => {
  return axios.request({
    url: '/salary/allowance/allowancelist/',
    data,
    method: 'post'
  })
}

// 薪酬津贴方案--列表【韩雪龙】
export const allowanceList = (data) => {
  return axios.request({
    url: '/salary/allowance/list/',
    params:data,
    method: 'get'
  })
}


// 薪酬津贴方案--详情【韩雪龙】
export const allowanceInfo = (data) => {
  return axios.request({
    url: '/salary/allowance/info/',
    data,
    method: 'post'
  })
}


// 字典-津贴发放内型【韩雪龙】
export const allowancetype = (data) => {
  return axios.request({
    url: '/option/dictionary/allowancetype',
    data,
    method: 'post'
  })
}

// 调薪记录
export const adjustRecord = (data) => {
  return axios.request({
    url: '/salary/adjustment/list/',
    data,
    method: 'post',
  })
}

// 调薪记录详情
export const adjustDetial = (data) => {
  return axios.request({
    url: '/salary/adjustment/info/',
    data,
    method: 'post'
  })
}

// 调薪原因字典
export const adjustmentCause = (data) => {
  return axios.request({
    url: '/option/dictionary/adjustmentcause',
    data,
    method: 'post'
  })
}

// 调薪项
export const adjustInfo = (data) => {
  return axios.request({
    url: '/salary/adjustment/infoadd/',
    data,
    method: 'post'
  })
}

// 年终奖列表
export const yearBonusList = (data) => {
  return axios.request({
    url: '/salary/yearbonus/list/',
    data,
    method: 'post',
  })
}

// 年终奖详情列表
export const bonusDetailList = (data) => {
  return axios.request({
    url: '/salary/yearbonus/detaillist/',
    data,
    method: 'post',
  })
}

// 审批测试
export const approvalTest = (data) => {
  return axios.request({
    url: '/approval/test/gettemp',
    data,
    method: 'post'
  })
}



// 工资--员工详情列表
export const salaryMonthly = (data) => {
  return axios.request({
    url: '/salary/monthly',
    params:data,
    method: 'get'
  })
}

// 薪酬--导入历史薪酬明细列表【韩雪龙】
export const importedSalary = (data) => {
  return axios.request({
    url: '/salary/historysalary/detaillist',
    params:data,
    method: 'get'
  })
}

// 工资--月汇总列表
export const salaryList = (data) => {
  return axios.request({
    url: '/salary/list',
    params:data,
    method: 'get'
  })
}


// 获取目前的日考勤报表 通过年月获取指定月份的考勤报表
export const reportByDate = (data) => {
  return axios.request({
    url: '/report/ByDate',
    data,
    method: 'post'
  })
}


// 通过年月获取指定月份的考勤报表【李旭阳】
export const reportByMonth = (data) => {
  return axios.request({
    url: '/report/ByMonth',
    data,
    method: 'post'
  })
}

// 审批记录
export const empApprovalList = (data) => {
  return axios.request({
    url: '/approval/approvalflow/getapprovaluserflowcontentlist',
    data,
    method: 'post',
  })
}

// 审批类型
export const entApprovalType = (data) => {
  return axios.request({
    url: '/approval/approvalflow/getenterpriseapprovalfolwtemplates',
    data,
    method: 'post',
  })
}

// 企业审批模板
export const entApprovalFlows = (data) => {
  return axios.request({
    url: '/approval/approvalflow/getenterpriseapprovalflows',
    data,
    method: 'post',
  })
}

// 企业审批表单-根据模板id
export const aprlFormControls = (data) => {
  return axios.request({
    url: '/approval/approvalflow/getapprovalflowcontrolsbyid',
    data,
    method: 'post',
  })
}

// 企业审批流-根据模板ID
export const aprlFlowPathItem = (data) => {
  return axios.request({
    url: '/approval/approvalflow/getapprovalflowitemsbyid',
    data,
    method: 'post',
  })
}

// 【1032】获取调休记录【李旭阳】
export const daysOffRecord = (data) => {
  return axios.request({
    url: '/report/DaysOff',
    data,
    method: 'post',
  })
}


// 【1033】获取加班记录【李旭阳】
export const overTimeRecord = (data) => {
  return axios.request({
    url: '/report/OverTime',
    data,
    method: 'post',
  })
}

// 审批设置开启关闭
export const approvalState = (data) => {
  return axios.request({
    url: '/approval/approvalflow/updateflowtemplatestate',
    data,
    method: 'post',
  })
}


// 控制台统计
export const workbenchStatistics = (data) => {
  return axios.request({
    url: '/enterprise/home/statistics',
    data,
    method: 'post',
  })
}

// 审批流系统数据
export const aprlFlowColn = (data) => {
  return axios.request({
    url: '/approval/approvalflow/getsyscolumnlist',
    data,
    method: 'post',
  })
}

//审批详情
export const aprlDetail = (data) => {
  return axios.request({
    url: '/approval/approvalflow/getapprovaluserflowcontentbyidinsystem',
    data,
    method: 'post',
  })
}

//审批记录-各审批状态的数量
export const empApprovalCount = (data) => {
  return axios.request({
    url: '/approval/approvalflow/getenterpriseapprovalflowcount',
    data,
    method: 'post'
  })
}

//审批通过
export const aprlRatify = (data) => {
  return axios.request({
    url: '/approval/approvalflow/approvalratifyonmanagerbatch',
    data,
    method: 'post'
  })
}

//审批驳回
export const aprlOverruled = (data) => {
  return axios.request({
    url: '/approval/approvalflow/approvaloverruleonmanagerbatch',
    data,
    method: 'post'
  })
}

//重新生成本月账单
export const rebuildCost = (data) => {
  return axios.request({
    url: '/Insurance/Cost/BuildBillByPlan',
    data,
    method: 'post'
  })
}



//调岗信息获取
export const empoyeeDimissionInfo = (data) => {
  return axios.request({
    url: '/employee/EmpoyeeDimissionInfo',
    data,
    method: 'post'
  })
}




//删除月保险账单
export const deleteInsCost = (data) => {
  return axios.request({
    url: '/Insurance/Cost/DeleteCostSummary',
    data,
    method: 'post'
  })
}

//待入职人员列表
export const waitList = (data) => {
  return axios.request({
    url: '/employee/waitentry/list',
    data,
    method: 'post'
  })
}

//待入职添加编辑
export const waitAddEdit = (data) => {
  return axios.request({
    url: '/employee/waitentry/addoredit',
    data,
    method: 'post'
  })
}

//待入职员工详情
export const waitDetail = (data) => {
  return axios.request({
    url: '/employee/waitentry/detail',
    data,
    method: 'post'
  })
}

//员工属性审核列表
export const fieldList = (data) => {
  return axios.request({
    url: '/employee/field/list',
    data,
    method: 'post'
  })
}

//员工属性审核详情
export const fieldDetail = (data) => {
  return axios.request({
    url: '/employee/field/detaillist',
    data,
    method: 'post'
  })
}

//员工审核操作
export const fieldAudit = (data) => {
  return axios.request({
    url: '/employee/field/audit',
    data,
    method: 'post'
  })
}

//权限-角色列表
export const pmsnList = (data) => {
  return axios.request({
    url: '/permission/permissiongrouplist',
    params: data,
    method: 'get'
  })
}

//管理员列表
export const sysMgrList = (data) => {
  return axios.request({
    url: 'permission/managerlist',
    params: data,
    method: 'get'
  })
}

//添加角色
export const permissionGroupAdd = (data) => {
  return axios.request({
    url: '/permission/permissiongroupadd',
    data,
    method: 'post'
  })
}

//添加角色时各模块
export const permissionRelation = (data) => {
  return axios.request({
    url: '/permission/permissionrelationlist',
    params: data,
    method: 'get'
  })
}

export const permissionRelationSimple = (data) => {
  return axios.request({
    url: '/permission/permissionlist',
    params: data,
    method: 'get'
  })
}
//角色详情
export const permissionDetail = (data) => {
  return axios.request({
    url: '/permission/permissiongroupdetail',
    params: data,
    method: 'get'
  })
}
//删除角色
export const permissionDelete = (data) => {
  return axios.request({
    url: '/permission/permissiongroupdelete',
    params: data,
    method: 'post'
  })
}

//添加管理员
export const manageradd = (data) => {
  return axios.request({
    url: '/permission/manageradd',
    data,
    method: 'post'
  })
}
//角色组列表下拉
export const pmsnListSelect = (data) => {
  return axios.request({
    url: '/permission/permissiongrouplistforselect',
    params: data,
    method: 'get'
  })
}
//管理员详情
export const managerdetail = (data) => {
  return axios.request({
    url: '/permission/managerdetail',
    params: data,
    method: 'get'
  })
}
//删除管理员
export const managerdelete = (data) => {
  return axios.request({
    url: '/permission/managerdelete',
    params: data,
    method: 'post'
  })
}
//转正员工信息
export const empFullNumInfo = (data) => {
  return axios.request({
    url: '/employee/positive/emppositiveinfo',
    params: data,
    method: 'get'
  })
}
//员工转正发起
export const applyFullEmployee = (data) => {
  return axios.request({
    url: '/employee/positive/applypositive',
    data,
    method: 'post'
  })
}
//自定义员工属性
export const empcustomfield = (data) => {
  return axios.request({
    url: '/employee/customfield/list',
    data,
    method: 'post'
  })
}
//新增自定义员工属性
export const empcustomfieldadd = (data) => {
  return axios.request({
    url: '/employee/customfield/addoredit',
    data,
    method: 'post'
  })
}
//删除自定义员工属性
export const empcustomfielddelete = (data) => {
  return axios.request({
    url: '/employee/customfield/delete',
    data,
    method: 'post'
  })
}
//自定义员工属性详情
export const empcustomfieldinfo = (data) => {
  return axios.request({
    url: '/employee/customfield/info',
    params: data,
    method: 'get'
  })
}
//针对考勤导入失败列表   签到，调休，年假
export const importAttendanceFailList = (data)=>{
  return axios.request({
    url:'/excel/imports/global/ImportLogList',
    data,
    method:'post'
  })
}



//***系统**** 审批 接口数据列表
export const approvalInterfaceData = (data)=>{
  return axios.request({
    url:'/flow/getsyscontrolurl',
    data,
    method:'post'
  })
}

//员工工资标准报表
export const payrollReportForm = (data) => {
  return axios.request({
    url: '/salary/employeeregular/list',
    params: data,
    method: 'get'
  })
}

// 员工岗位序列
export const employeePostList = (data) => {
  return axios.request({
    url: '/enterprise/jobposition/category/listsimple',
    params: data,
    method: 'get'
  })
}
// 获取员工成本编号列表
export const listjobcost = (data) => {
  return axios.request({
    url: '/enterprise/jobposition/listjobcost',
    data,
    method: 'post'
  })
}

// 成本中心 列表
export const costCenterList = (data) => {
  return axios.request({
    url: '/employee/costcenter/list',
    data,
    method: 'post'
  })
}

// 合同公司列表
export const getContractCompanyList = (data) => {
  return axios.request({
    url: '/enterprise/company/companylist',
    params: data,
    method: 'get'
  })
}
// 添加合同公司
export const addContractCompany = (data) => {
  return axios.request({
    url: '/enterprise/company/add',
    data,
    method: 'post'
  })
}
// 编辑合同公司
export const editContractCompany = (data) => {
  return axios.request({
    url: '/enterprise/company/edit',
    data,
    method: 'post'
  })
}
// 删除合同公司
export const delContractCompany = (data) => {
  return axios.request({
    url: '/enterprise/company/delete',
    data,
    method: 'post'
  })
}

// 独立工资条
// list列表
export const paystubList = (data) => {
    return axios.request({
        url: '/dispatch/wage/listsummary',
        params:data,
        method: 'get'
    })
}
// 发放、撤回工资条
export const sendpayslip = (data) => {
    return axios.request({
        url: '/dispatch/wage/sendpayslip',
        data,
        method: 'post'
    })
}
// 工资条详情列表
export const paystubDetailList = (data) => {
    return axios.request({
        url: '/dispatch/wage/list',
        params:data,
        method: 'get'
    })
}
// 月工资条删除
export const deletesummarywage = (data) => {
    return axios.request({
        url: '/dispatch/wage/deletesummarywage',
        data,
        method: 'post'
    })
}

// 员工工资条删除
export const deleteemployeewage = (data) => {
    return axios.request({
        url: '/dispatch/wage/deleteemployeewage',
        data,
        method: 'post'
    })
}

// 员工详情 岗位信息编辑  岗位序列
export const getJobList = (data) => {
    return axios.request({
        url: '/employee/empPositionSequence',
        params:data,
        method: 'get'
    })
}

//个税纠错加载信息
export const emplTaxInfo = (data) => {
  return axios.request({
    url: '/salary/taxinfo',
    params: data,
    method: 'get'
  })
}

//企业邀请列表
export const invitesList = (data) => {
    return axios.request({
      url: '/enterprise/invites',
      data,
      method: 'post'
    })
}
// 获取企业要求积分
export const inviteScore = (data) => {
    return axios.request({
      url: '/enterprise/score',
      data,
      method: 'post'
    })
}
// 消息通知列表
export const notifyList = (data) => {
    return axios.request({
      url: '/announcement/getlist',
      params: data,
      method: 'get'
    })
}
// 添加消息通知
export const addNotify = (data) => {
    return axios.request({
      url: '/announcement/add',
      data,
      method: 'post'
    })
}
// 发布消息通知
export const publishNotify = (data) => {
    return axios.request({
      url: '/announcement/publish',
      data,
      method: 'post'
    })
}
// 删除消息通知
export const delNotify = (data) => {
    return axios.request({
      url: '/announcement/del',
      data,
      method: 'post'
    })
}
// 消息通知详情
export const notifyInfo = (data) => {
    return axios.request({
      url: '/announcement/get',
      params: data,
      method: 'get'
    })
}
// 消息通知类型获取
export const notifyType = (data) => {
    return axios.request({
      url: '/announcement/type',
      params: data,
      method: 'get'
    })
}


// WEBPACK FOOTER //
// ./src/api/data.js